/**
 * Значки категорий уведомлений. Тексты уведомления — общие с приложением
 * (client-core/notifications/text.ts) и отсюда только переэкспортируются.
 */

import {
  AlarmClock,
  AtSign,
  BellRing,
  CalendarClock,
  CalendarX,
  CheckSquare,
  FilePlus,
  ArchiveRestore,
  Archive,
  ListTree,
  MessageSquare,
  NotebookPen,
  Paperclip,
  PenLine,
  Trash2,
  TreePalm,
  UserMinus,
  UserPlus,
  Users,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { NotificationCategory } from "@taskflow/contracts";


export {
  actorTextOf,
  CATEGORY_LABELS,
  headlineOf,
  linkOf,
  reminderMomentLabel,
  summaryOf,
} from "@taskflow/client-core/notifications";

export const CATEGORY_ICONS: Record<NotificationCategory, LucideIcon> = {
  [NotificationCategory.ASSIGNED]: UserPlus,
  [NotificationCategory.UNASSIGNED]: UserMinus,
  [NotificationCategory.MENTIONED]: AtSign,
  [NotificationCategory.COMMENT]: MessageSquare,
  [NotificationCategory.OVERDUE]: CalendarX,
  [NotificationCategory.TASK_REMINDER]: AlarmClock,
  [NotificationCategory.STATUS_CHANGED]: CheckSquare,
  [NotificationCategory.FIELDS_CHANGED]: PenLine,
  [NotificationCategory.ATTACHMENT]: Paperclip,
  [NotificationCategory.SUBTASK]: ListTree,
  [NotificationCategory.ARCHIVED]: Archive,
  [NotificationCategory.RESTORED]: ArchiveRestore,
  [NotificationCategory.BOARD_INVITE]: Users,
  [NotificationCategory.NOTE_INVITE]: NotebookPen,
  [NotificationCategory.NOTE_REMINDER]: BellRing,
  [NotificationCategory.VACATION_UPCOMING]: TreePalm,
  [NotificationCategory.VACATION_CONFLICT]: Users,
  [NotificationCategory.VACATION_CHANGED]: CalendarClock,
  [NotificationCategory.TASK_CREATED]: FilePlus,
  [NotificationCategory.TASK_DELETED]: Trash2,
};
